"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const referralHistoryInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Your referrals",
  },
  {
    name: "dateLabel",
    type: "string",
    required: true,
    defaultValue: "Date",
  },
  {
    name: "eventLabel",
    type: "string",
    required: true,
    defaultValue: "Referral",
  },
  {
    name: "pointsLabel",
    type: "string",
    required: true,
    defaultValue: "Reward",
  },
  {
    name: "pointsUnit",
    type: "string",
    defaultValue: "points",
  },
  {
    name: "rowsCount",
    type: "number",
    min: 1,
    defaultValue: 5,
    required: true,
  },
  {
    name: "text",
    friendlyName: "Link's label",
    type: "string",
    defaultValue: "View all referral history",
    required: true,
  },
  {
    name: "url",
    friendlyName: "Link's URL",
    type: "url",
    defaultValue: "#",
    required: true,
  },
] as const satisfies Inputs;

export const ReferralHistoryComponent: RegisteredComponent = {
  name: "ReferralHistory",
  component: dynamic(async () =>
    withValidation(referralHistoryInputs, (await import("./ReferralHistory")).ReferralHistory, "ReferralHistory")
  ),
  inputs: referralHistoryInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'ReferralHistory' component can only be added inside a 'LoyaltyWrapper'",
  },
};
